import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { getAllStudents } from '../../redux/actions/users';

import { ContainerFull } from '../../components/ContainerFull';
import { Heading } from '../../components/Heading';
import { Wrapper } from '../../components/Wrapper';

import { formatDate } from '../../common/formatDateText';

import './styles.css';
import { UserIcon, AdjustmentsHorizontalIcon, DocumentArrowDownIcon } from '@heroicons/react/20/solid';
import { Loading } from '../../components/loading/Loading';
import { Tooltip, Zoom } from '@mui/material';
import { DataTableCustom } from '../../components/dataTable/DataTableCustom';
import { useEffect, useRef, useState } from 'react';
import { statusStudentsFilter, statusSubscriptionFilter } from '../../static/data';
import { DropDownFilterSingle } from '../../components/dropDown/DropDownFilterSingle';
import { DrawerFiltersStudents } from './DrawerFiltersStudents';
import { verifyStateApp } from '../../redux/actions/stateApp';
import { toast } from 'react-hot-toast';
import { exportToExcel } from '../../common/importDataToExcel';

function classNames(...classes) {
	return classes.filter(Boolean).join(' ')
}

export const StudentsPage = () => {
	const dispatch = useDispatch();
	const {
		students,
		loading,
	} = useSelector((state) => state.users);
	const timeoutRef = useRef(null);
	const [rows, setRows] = useState([]);
	const [searchText, setSearchText] = useState('');
	const [isOpenDrawerFilters, setIsOpenDrawerFilters] = useState(false);
	const [filterOption, setFilterOption] = useState("");
	const [filterOptionSuscription, setFilterOptionSuscription] = useState("");
	const [pageSizeOptions, setpageSizeOptions] = useState({
		pageSize: 15,
		page: 0,
		totalRows: 0
	});

	const [formData, setFormData] = useState({
		fromDate: '',
		toDate: '',
		identifier: '',
		sort: {
			"value": "desc",
			"label": "Mas reciente"
		},
	});

	useEffect(() => {
		setRows(students);
	}, [students]);

	useEffect(() => {
		dispatch(getAllStudents({
			fromDate: formData?.fromDate ? formData.fromDate : '',
			toDate: formData?.toDate ? formData.toDate : '',
			statusStudent: filterOption,
			statusSubscription: filterOptionSuscription,
			identifier: formData?.identifier ? formData.identifier.description : '',
			query: searchText,
			usePagination: true,
			sort: {
				value: "desc",
				label: "Mas reciente"
			},
			page: 0,
			pageSize: 15,
		}))
			.then(((result) => {
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
	}, [filterOption, filterOptionSuscription, dispatch])

	const handlePageChange = (model) => {
		setpageSizeOptions(model);
		dispatch(getAllStudents({
			fromDate: formData?.fromDate ? formData.fromDate : '',
			toDate: formData?.toDate ? formData.toDate : '',
			statusStudent: filterOption,
			statusSubscription: filterOptionSuscription,
			identifier: formData?.identifier ? formData.identifier.description : '',
			query: searchText,
			usePagination: true,
			sort: {
				value: "desc",
				label: "Mas reciente"
			},
			page: model.page,
			pageSize: model.pageSize,
		})).then(((result) => {
			if (result.status === 200) {
				setpageSizeOptions({
					pageSize: result.pageSize,
					page: result.page,
					totalRows: result.totalRows
				})
			}
		}
		));
	}

	const handleSearchChange = (e) => {
		setSearchText(e.target.value);
		// Cancelamos el timeout anterior si el usuario sigue escribiendo
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
		// Esperamos 500ms desde el último cambio antes de ejecutar la lógica
		timeoutRef.current = setTimeout(() => {
			// ya puedes hacer fetch, actualizar estado global, etc.
			searchUserByQuery(e.target.value);
		}, 1000);
	}


	const searchUserByQuery = (query) => {
		dispatch(getAllStudents({
			fromDate: formData?.fromDate ? formData.fromDate : '',
			toDate: formData?.toDate ? formData.toDate : '',
			statusStudent: filterOption,
			statusSubscription: filterOptionSuscription,
			identifier: formData?.identifier ? formData.identifier.description : '',
			query: searchText,
			usePagination: true,
			sort: {
				value: "desc",
				label: "Mas reciente"
			},
			page: 0,
			pageSize: 15
		}))
			.then(((result) => {
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
	}

	const columns = [
		{
			field: 'action',
			headerName: '',
			width: 150,
			sortable: false,
			disableColumnMenu: true,
			renderCell: (params) => (
				<div className='w-full flex justify-center gap-4'>
					<Tooltip title="Ver perfil del estudiante" TransitionComponent={Zoom} placement='left'>
						<Link
							to={`/perfil/${params.id}`}
							className="flex justify-center border-gray-200 border-1 bg-gray-100 uppercase px-3 py-2 text-slate-700 rounded hover:bg-gray-300"
						>
							<UserIcon className="block h-5 w-5" aria-hidden="true" />
						</Link>
					</Tooltip>
				</div>
			),
		},
		{
			field: 'status',
			headerName: 'Estatus',
			width: 200,
			renderCell: (params) => (
				<div className={classNames(
					params.value === 'activo'
						? 'text-emerald-600 bg-emerald-100'
						: params.value === 'inactivo' ? 'text-gray-600  bg-gray-100'
							: params.value === 'baja' ? 'text-rose-500 bg-rose-100'
								: 'text-gray-560 bg-gray-100',
					'font-bold flex justify-center w-[100px] py-1 px-1  rounded-md uppercase'
				)}>
					<p className="text-[.8rem]">{params.value}</p>
				</div>
			),
		},
		{
			field: 'statusSubscription',
			headerName: 'Suscripcion',
			width: 200,
			renderCell: (params) => (
				<div className={classNames(
					params.value === 'pagado'
						? 'text-emerald-600 bg-emerald-100'
						: params.value === 'inactivo' ? 'text-gray-600  bg-gray-100'
							: params.value === 'vencida' ? 'text-rose-500 bg-rose-100'
								: 'text-gray-600 bg-gray-100',
					'font-bold flex justify-center w-[100px] py-1 px-1  rounded-md uppercase'
				)}>
					<p className="text-[.8rem]">{params.value}</p>
				</div>
			),
		},
		{
			field: 'paymentDeadlineDate',
			headerName: 'Fecha de vencimiento',
			width: 250,
			renderCell: (params) => (
				<p className='capitalize w-[200px] text-center bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>{formatDate(params.value)}</p>
			)
		},
		{
			field: 'matricula',
			headerName: 'Matricula',
			width: 150,
			renderCell: (params) => (
				<p className='text-slate-600 font-semibold'>{params.value}</p>
			),
		},
		{
			field: 'nameUser',
			headerName: 'Estudiante',
			width: 300,
			renderCell: (params) => (
				<p className='capitalize'>{params.value}</p>
			),
		},
		{
			field: 'subscriptionPayment',
			headerName: 'Suscripcion',
			width: 150,
			renderCell: (params) => (
				<div className='w-full flex justify-center items-center'>
					{
						params.value && (
							<p className='capitalize text-center bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>{`$ ${params.value}`}</p>
						)
					}
				</div>
			)
		},
		{
			field: 'email',
			headerName: 'Correo Electronico',
			width: 300
		},
		{
			sortable: false,
			field: 'dateBirth',
			headerName: 'Fecha de nacimiento',
			width: 250,
			renderCell: (params) => (
				<p className='capitalize w-[200px] text-center bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>{formatDate(params.value)}</p>
			)
		},
		{
			field: 'phone',
			headerName: 'Telefono',
			width: 200,
			renderCell: (params) => (
				<p className='capitalize'>{params.value}</p>
			),
		},
		{
			field: 'location',
			headerName: 'Ubicacion',
			width: 250,
			renderCell: (params) => (
				<p className='capitalize'>{params.value}</p>
			),
		},
		{
			field: 'education',
			headerName: 'Educacion',
			width: 250,
			renderCell: (params) => (
				<p className='capitalize'>{params.value}</p>
			),
		},
		{
			field: 'createdBy',
			headerName: 'Inscrito por',
			width: 300,
			renderCell: (params) => (
				<p className='capitalize'>{params.value}</p>
			),
		},
		{
			field: 'createdAt',
			headerName: 'Fecha de inscripcion',
			width: 250,
			renderCell: (params) => (
				<p className='capitalize w-[200px] text-center bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>{formatDate(params.value)}</p>
			)
		},
		{
			field: 'numCourses',
			headerName: 'Cursos',
			width: 150,
			renderCell: (params) => (
				<div className='w-[100%] flex justify-start'>
					<p className='capitalize bg-slate-200 px-3 py-1 font-semibold rounded-md text-sm text-gray-700'>
						{params.value}
					</p>
				</div>
			)
		},
		{
			field: 'courseIdentifiers',
			headerName: 'Identificadores de cursos',
			sortable: false,
			width: 350,
			renderCell: (params) => (
				<div className='course-identifiers'>
					{
						params.value.map((item, index) => <p key={`item-${item}-${index}`} className='text-center capitalize bg-slate-200 px-3 py-1 rounded-md text-sm text-gray-700'>{`${item}`}</p>)
					}
				</div>
			),

		},
	];

	const handleApllyFilters = () => {
		dispatch(getAllStudents({
			fromDate: formData?.fromDate ? formData.fromDate : '',
			toDate: formData?.toDate ? formData.toDate : '',
			statusStudent: filterOption,
			statusSubscription: filterOptionSuscription,
			identifier: formData?.identifier ? formData.identifier.description : '',
			query: searchText,
			usePagination: true,
			sort: formData?.sort ? formData.sort : {
				"value": "desc",
				"label": "Mas reciente"
			},
			page: pageSizeOptions.page,
			pageSize: pageSizeOptions.pageSize,
		}))
			.then(((result) => {
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
		toggleDrawerFilters();
	}

	const handleRemoveFilter = () => {
		setFormData({
			fromDate: '',
			toDate: '',
			identifier: '',
			sort: {
				"value": "desc",
				"label": "Mas reciente"
			},
		});
		dispatch(getAllStudents({
			fromDate: '',
			toDate: '',
			statusStudent: '',
			statusSubscription: '',
			identifier: '',
			query: '',
			usePagination: true,
			sort: {
				"value": "desc",
				"label": "Mas reciente"
			},
			page: 0,
			pageSize: 15,
		}))
			.then(((result) => {
				if (result.status === 200) {
					setpageSizeOptions({
						pageSize: result.pageSize,
						page: result.page,
						totalRows: result.totalRows
					})
				}
			}
			));
		toggleDrawerFilters();
	}


	const toggleDrawerFilters = () => {
		setIsOpenDrawerFilters((prevState) => !prevState);
	}


	const handleImportData = async (name) => {
		dispatch(verifyStateApp())
			.then((response) => {
				if (response.data === false) {
					toast.error(response.message)
				} else {
					confirDownloadFile(name);
				}
			});
	}

	const confirDownloadFile = async (name) => {
		let excelData = [];
		dispatch(getAllStudents({
			fromDate: formData?.fromDate ? formData.fromDate : '',
			toDate: formData?.toDate ? formData.toDate : '',
			statusStudent: filterOption,
			statusSubscription: filterOptionSuscription,
			identifier: formData?.identifier ? formData.identifier.description : '',
			query: searchText,
			usePagination: false,
			sort: {
				"value": "desc",
				"label": "Mas reciente"
			},
			page: pageSizeOptions.page,
			pageSize: pageSizeOptions.pageSize,
			sendExcel: true
		}))
			.then(((result) => {
				if (result.status === 200) {
					excelData = result.excelData
					const response = exportToExcel(excelData, name);
					response.data
						? toast.error(response.message)
						: toast.success(response.message);
				}
			}
			));
	}

	return (
		<ContainerFull>
			<Heading
				title={`Lista de estudiantes`}
				subtitle={`Muestra la lista de todos los estudiantes registrados en la plataforma.`}
				center={false}
			/>
			<div className='w-full flex justify-end mt-4 gap-4'>
				<div>
					<Tooltip title="Descargar archivo de Excel" TransitionComponent={Zoom} placement='top'>
						<button
							type='button'
							onClick={() => handleImportData('Lista_de_estudiantes.xlsx')}
							className='rounded-md px-4 py-2 font-semibold text-md text-white bg-indigo-600 shadow-sm shadow-indigo-600 hover:bg-indigo-800'
						><DocumentArrowDownIcon className="block h-5 w-5" aria-hidden="true" /></button>
					</Tooltip>
				</div>
				<div>
					<Tooltip title="Panel de filtros" TransitionComponent={Zoom} placement='top'>
						<button
							type='button'
							onClick={() => toggleDrawerFilters()}
							className='rounded-md px-4 py-2 font-semibold text-md text-white bg-indigo-600 shadow-sm shadow-indigo-600 hover:bg-indigo-800'
						><AdjustmentsHorizontalIcon className="block h-5 w-5" aria-hidden="true" /></button>
					</Tooltip>
				</div>
				<div>
					<DropDownFilterSingle
						title={"Estatus de suscripcion"}
						options={statusSubscriptionFilter}
						state={filterOptionSuscription}
						setState={setFilterOptionSuscription}
					/>
				</div>
				<div>
					<DropDownFilterSingle
						title={"Estatus estudiante"}
						options={statusStudentsFilter}
						state={filterOption}
						setState={setFilterOption}
					/>
				</div>
			</div>
			{students && (
				<>
					<Wrapper>
						<input
							type="text"
							placeholder="Buscar un estudiante"
							value={searchText}
							onChange={handleSearchChange}
							className='block w-full rounded-md border-0 py-2 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6' />
					</Wrapper>

					<Wrapper>
						<div className='overflow-x-auto'>
							{
								loading
									? (
										<Loading />
									) : (
										<>
											{
												rows.length > 0
													? (
														<DataTableCustom
															rows={rows}
															columns={columns}
															pageSizeOptions={pageSizeOptions}
															onPageChange={handlePageChange}
														/>
													) : (
														<p className='text-gray-400'>No hay registro de estudiantes</p>
													)
											}
										</>
									)
							}
						</div>
					</Wrapper>
				</>

			)}
			<DrawerFiltersStudents
				isOpenDrawerFilters={isOpenDrawerFilters}
				toggleDrawerFilters={toggleDrawerFilters}
				formData={formData}
				setFormData={setFormData}
				handleApllyFilters={handleApllyFilters}
				handleRemoveFilter={handleRemoveFilter}
			/>
		</ContainerFull>
	);
}
